import { FormattedMessage } from 'react-intl';

import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { useUserContext } from '@/context/UserContext.tsx';
import type { Way } from '@/types/common.ts';

type OptionWayMessageProps = {
  way: Way;
  'data-e2e': string;
};

export function OptionWayMessage({ way, 'data-e2e': dataE2e }: OptionWayMessageProps) {
  const {
    currentUser: { userType },
  } = useUserContext();
  const isInternalSales = userType === 'Internal Sales';
  const isClientWay = way === 'Ask';

  const { strategyPanelVisible, productName } = useOptionSelector((option) => {
    return {
      strategyPanelVisible: option.properties.uiState.strategyPanelMode !== 'hidden',
      productName: option.type,
    };
  });

  if (strategyPanelVisible && isClientWay) {
    return (
      <div className="fs-12" data-e2e={dataE2e}>
        <FormattedMessage id="option.fields.your.way" values={{ isInternalSales }} />
      </div>
    );
  }

  if (strategyPanelVisible && !isClientWay) {
    return <div data-e2e={dataE2e}>&nbsp;</div>;
  }

  return (
    <div className="fs-12" data-e2e={dataE2e}>
      {productName === 'RiskReversal' ? (
        <FormattedMessage
          id={way === 'Bid' ? 'option.way.RiskReversal.sell' : 'option.way.RiskReversal.buy'}
          values={{ isInternalSales }}
        />
      ) : (
        <FormattedMessage id={way === 'Bid' ? 'option.way.sell' : 'option.way.buy'} values={{ isInternalSales }} />
      )}
    </div>
  );
}

